import { createSlice } from '@reduxjs/toolkit'
import { format } from 'date-fns';
import { COUNTRY_LIST } from '../components/booking/countries';


const initialState = 
    {
        page: "HOME",
        section: "HOME",
        activity: "",
        params: null,
        mode: "STANDARD",
        directBooking: false,
        arrivalDate: null,
        guestNames: null,
        vip: false,
        formFactor: "MOBILE",
        menuDisplayed: false,
        bookings: null,
        rates: null,
        bookingSelected: null,
        selectedDuration: 7,
        cost: 0,
        mandatoryFieldsMissing: false,
        invalidEmail: false,
        invalidMobileNumber: false,
        invalidPostCode: false,
        invalidInternationalPhoneNumber: false,
        clientSecret: null,
        paymentIntentId: null,
        paymentIntentAmount: 0,
        stripeMessage: null,
        stripeIsLoading: false,
        bookingDetails : {
            arrivalDate: null,
            audit : {
                balanceDue: 0.0,
                booker: "direct",
                dateBalanceDue: null,
                introductoryEmailSent: false,
                numberOfPreviousVisits: 0,
                paidToDate: 0.0,
                paymentReference: null,
                thankYouEmailSent: false,
                vip: false,
                visitEmailSent: false
            },
            cancellationReason: null,
            carChargingPayment: 0.0,
            contactDetails: {
                email: "",
                homeNumber: "",
                mobileNumber: "",
                countryCode: "44",
                internationalPhoneNumber: "",
                postCode: "",
                country: "United Kingdom"
            },
            cotRequired: false,
            customerDetails: {
                firstName: "",
                surname: "",
                title: "Mr"
            },
            dateBookingMade: null,
            deposit: 0.0,
            duration: 0,
            electricCar: false,
            highChairRequired: false,
            notes: null,
            numberOfAdults: 1,
            numberOfChildren: 0,
            numberOfInfants: 0,
            numberOfPets: 0,
            petPayment: 0.0,
            rate: 0,
            specialRequirements: "None",
            status: "booked",
            termsAndConditionsAgreed: false,
            totalAmount: 0.0,
        }
    }


const appSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setSection(state, action) {
        state.section = action.payload;
    },
    setActivity(state, action) {
        state.activity = action.payload;
    },
    setFormFactor(state, action) {
        state.formFactor = action.payload;
    },
    setParams(state, action) {
        state.params = action.payload;
    },
    setMode(state, action) {
        state.mode = action.payload;
    },
    setArrivalDate(state, action) {
        state.arrivalDate = action.payload;
    },
    setGuestNames(state, action) {
        state.guestNames = action.payload;
    },
    setVIP(state, action) {
        state.vip = action.payload;
    },
    setBookings(state, action) {
        state.bookings = action.payload;
    },
    setRates(state, action) {
        state.rates = action.payload;
    },
    setBookingSelected(state, action) {
        state.bookingSelected = action.payload;
        state.bookingDetails.arrivalDate = action.payload;
    },
    setDuration(state, action) {
        state.selectedDuration = action.payload;
        state.bookingDetails.duration = parseInt(action.payload);
    },
    setCost(state, action) {
        state.cost = action.payload;
        state.bookingDetails.rate = action.payload;
    },
    setCustomerSurname(state, action) {
        state.bookingDetails.customerDetails.surname = action.payload;
    },
    setCustomerFirstName(state, action) {
        state.bookingDetails.customerDetails.firstName = action.payload;
    },
    setCustomerTitle(state, action) {
        state.bookingDetails.customerDetails.title = action.payload;
    },
    setCustomerEmail(state, action) {
        state.bookingDetails.contactDetails.email = action.payload;
    },
    setCustomerHomePhone(state, action) {
        state.bookingDetails.contactDetails.homeNumber = action.payload;
    },
    setCustomerMobilePhone(state, action) {
        state.bookingDetails.contactDetails.mobileNumber = action.payload;
    },
    setCustomerCountryCode(state, action) {
        state.bookingDetails.contactDetails.countryCode = action.payload;
    },
    setCustomerInternationalPhoneNumber(state, action) {
        state.bookingDetails.contactDetails.internationalPhoneNumber = action.payload;
    },
    setCustomerPostCode(state, action) {
        state.bookingDetails.contactDetails.postCode = action.payload.toUpperCase();
    },
    setCustomerCountry(state, action) {
        state.bookingDetails.contactDetails.country = action.payload;
        let countryCode = COUNTRY_LIST.find((element) => {
                                                if (element.id === action.payload) {
                                                    return element;
                                                }
                                            });
        countryCode ? state.bookingDetails.contactDetails.countryCode = countryCode.key : state.bookingDetails.contactDetails.countryCode = "";                                          

    },
    setNumberOfAdults(state, action) {
        state.bookingDetails.numberOfAdults = parseInt(action.payload);
    },
    setNumberOfChildren(state, action) {
        state.bookingDetails.numberOfChildren = parseInt(action.payload);
    },
    setNumberOfInfants(state, action) {
        state.bookingDetails.numberOfInfants = parseInt(action.payload);
    },
    setNumberOfPets(state, action) {
        state.bookingDetails.numberOfPets = parseInt(action.payload);
        state.bookingDetails.petPayment = parseInt(action.payload)*30;

    },
    setDateBookingMade(state, action) {
        state.bookingDetails.dateBookingMade = action.payload;
    },
    setDirectBooking(state, action) {
        state.directBooking = action.payload;
    },
    setElectricCarCharging(state, action) {
        state.bookingDetails.electricCar = action.payload;
        state.bookingDetails.carChargingPayment = (action.payload === true ? 50.0 : 0.0);
    },
    setHighChairRequired(state, action) {
        state.bookingDetails.highChairRequired = action.payload;
    },
    setTravelCotRequired(state, action) {
        state.bookingDetails.cotRequired = action.payload;
    },
    setMandatoryFieldsMissing(state, action) {
        state.mandatoryFieldsMissing = action.payload;
    },
    setInvalidEmail(state, action) {
        state.invalidEmail = action.payload;
    },
    setInvalidMobileNumber(state, action) {
        state.invalidMobileNumber = action.payload;
    },
    setInvalidPostCode(state, action) {
        state.invalidPostCode = action.payload;
    },
    setInvalidInternationalPhoneNumber(state, action) {
        state.invalidInternationalPhoneNumber = action.payload;
    },
    setClientSecret(state, action) {
        state.clientSecret = action.payload;
    },
    setPaymentIntentId(state, action) {
        state.paymentIntentId = action.payload;
    },
    setPaymentIntentAmount(state, action) {
        state.paymentIntentAmount = action.payload;
    },
    setStripeMessage(state, action) {
        state.stripeMessage = action.payload;
    },
    setStripeIsLoading(state, action) {
        state.stripeIsLoading = action.payload;
    },
    setSavedBookingDetails(state, action) {
        state.bookingDetails = action.payload;
    },
    setTotalAmount(state, action) {
        state.cost = action.payload;
        state.bookingDetails.totalAmount = action.payload;
    },
    setDeposit(state, action) {
        state.cost = action.payload;
        state.bookingDetails.deposit = action.payload;
    },
    setPaymentReference(state, action) {
        state.bookingDetails.audit.paymentReference = action.payload;
    },
    setPaidToDate(state, action) {
        state.bookingDetails.audit.paidToDate = action.payload;
    },
    setBalanceDue(state, action) {
        state.bookingDetails.audit.balanceDue = action.payload;
    },
    setBalanceDueDate(state, action) {
        state.bookingDetails.audit.dateBalanceDue = action.payload;
    },
    setTermsAndConditionsAgreed(state, action) {
        state.bookingDetails.termsAndConditionsAgreed = action.payload;
    }
  }
})

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setPage, setSection, setActivity, setFormFactor,  setParams, setMode,
               setArrivalDate, setGuestNames, setVIP, setBookings, setRates, setBookingSelected,
               setDuration, setCost, setCustomerSurname, setCustomerFirstName, setCustomerTitle,
               setCustomerEmail, setCustomerHomePhone, setCustomerMobilePhone, setCustomerPostCode,
               setNumberOfAdults, setNumberOfChildren, setNumberOfInfants, setNumberOfPets, setDateBookingMade,
               setDirectBooking, setElectricCarCharging, setHighChairRequired, setTravelCotRequired,
               setMandatoryFieldsMissing, setInvalidEmail, setInvalidMobileNumber, setInvalidPostCode,
               setClientSecret, setPaymentIntentId, setPaymentIntentAmount, setStripeMessage,
               setStripeIsLoading, setSavedBookingDetails, setTotalAmount, setDeposit,
               setPaymentReference, setPaidToDate, setBalanceDue, setBalanceDueDate,
               setTermsAndConditionsAgreed, setCustomerCountry, setCustomerCountryCode, setCustomerInternationalPhoneNumber,
               setInvalidInternationalPhoneNumber,
             } = appSlice.actions

// Export the slice reducer as the default export
export default appSlice.reducer